@if (isUserCreationInProcess()) {
<rs-loader></rs-loader>
}
<rs-dialog [visible]="isUserGotCreated()" heading="User Created" maxWidth="50%" class="bmt-create-user" (visibleChange)="isUserGotCreated.set($event); createUserForm.reset();">
    <div style="padding: 20px;">
      <p>A new user has been created! The user will receive a welcome email. Please do the following:</p>
      <ul>
      <li>Add Authorizations</li>
      <li>Let the User know their Username as they will need this to set up a Password</li>
      </ul>
    </div>
    <div style="padding: 20px;justify-content: space-between;display: flex;">
        <button style="width: auto;" rs-raised-button color="primary" (click)="createUserForm.reset(); isUserGotCreated.set(false)">Create Another User</button>
        <button style="width: auto;" rs-raised-button color="primary" (click)="manageAuthorizations();">Manage Authorizations</button>
    </div>
</rs-dialog>
<form [formGroup]="createUserForm" class="bmt-create-user" (ngSubmit)="createUser()">
    @if (createUserErrors()) {
    <h5 style="color: red;">{{createUserErrors()}}</h5>
    }
    <h4>Create New User</h4>
    <div class="row">
        <div class="col-sm-4">
            <rs-input validation="eager" formControlName="userIdentifier" class="create-user-inputs" label="User Name:"></rs-input>
        </div>
    </div>
    <h4>User Profile Information</h4>
    <div class="row">
        <div class="col-sm-4">
            <rs-input validation="eager" formControlName="firstName" class="create-user-inputs" label="First Name:"></rs-input>
            <rs-input validation="eager" formControlName="lastName" class="create-user-inputs" label="Last Name:"></rs-input>
            <rs-input validation="eager" formControlName="companyName" class="create-user-inputs" label="Company Name:"></rs-input>
            <rs-input validation="eager" type="email" formControlName="emailAddress" class="create-user-inputs" label="Email Address:"></rs-input>
            <rs-input validation="eager" type="email" formControlName="confirmEmail" class="create-user-inputs" label="Confirm Email Address:"></rs-input>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-5" style="justify-content: space-between;display: flex;">
            <button rs-raised-button color="secondary" (click)="createUserForm.reset();">Reset</button>
            <button [disabled]="!createUserForm.valid" rs-raised-button color="primary">Create User</button>
        </div>
    </div>
</form>
